import { store } from "../redux/store";

const LOGOUT_SUCCESS_FLAG = 'logoutSuccess';
export const LOGOUT_START_EVENT = 'rubios-logout-start';

export function isLoginUser() {
  const providerToken = store?.getState()?.providerReducer?.providerToken?.access_token;
  const authToken = store?.getState()?.authReducer?.authToken?.authtoken;
  return providerToken && authToken ? true : false
}

export function startLogoutLoading() {
  window.dispatchEvent(new Event(LOGOUT_START_EVENT));
}

export function markLogoutSuccess() {
  sessionStorage.setItem(LOGOUT_SUCCESS_FLAG, 'true');
}

export function consumeLogoutSuccess() {
  const flagged = sessionStorage.getItem(LOGOUT_SUCCESS_FLAG) === 'true';
  if (flagged) {
    sessionStorage.removeItem(LOGOUT_SUCCESS_FLAG);
  }
  return flagged;
}
